<template>
  <div>
    <v-layout wrap id="corporate">
      <v-flex xs12>
        <Corporate />
      </v-flex>
    </v-layout>
    <v-layout wrap id="partner">
      <v-flex xs12>
        <Partner />
      </v-flex>
    </v-layout>
    <v-layout wrap id="contactus">
      <v-flex xs12>
        <ContactUS />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Corporate from "./corporatePage.vue";
import Partner from "./partnerPage.vue";
import ContactUS from "./contactusPage.vue";

export default {
  components: {
    Corporate,
    Partner,
    ContactUS,
  },
};
</script>